export default __webpack_public_path__ + "static/media/retiro_seclantas2.ff61ea4c.jpg";